<script setup>
import { ref } from 'vue';
import ModalWrapper from '@/modals/ModalWrapper';
// Import the component
import LabProfileForm from '@/components/Lab/LabProfileForm';

defineProps({
    lab: {
        type: Object,
        default: () => ({
            primary_color: '#000000',
            secondary_color: '#000000',
            addresses: []
        }),
    },
    mode: {
        type: String,
        default: 'Create',
    },
});

const labProfileFormRef = ref(null);
const save = () => {
    if (labProfileFormRef.value) {
        labProfileFormRef.value.save(); // Call the save method in LabProfileForm
    }
};

</script>

<template>
<ModalWrapper>
    <template #header>{{
        $t("label.mode_what", { mode: mode, what: "lab" })
    }}</template>
    <template #subheader>{{
        $t("label.create_or_edit", { what: "lab" })
    }}</template>

    <LabProfileForm
        ref="labProfileFormRef"
        :lab="lab"
        :mode="mode"
        @saved="$emit('close-modal')" />

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>

</ModalWrapper>
</template>
